import { useSyncExternalStore } from "react"

/**
 * Tailwind's `md` breakpoint, above which the app lays out as two panes:
 * the chat list beside the open thread instead of one screen at a time.
 */
export const DESKTOP_QUERY = "(min-width: 768px)"

/** True while `query` matches; re-renders as the window crosses it. */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => {
      const list = window.matchMedia(query)
      list.addEventListener("change", onChange)
      return () => list.removeEventListener("change", onChange)
    },
    () => window.matchMedia(query).matches,
    () => false
  )
}
